export const ANNOUNCEMENT_OPTIONS = [
  "id",
  "title",
  "createdByUser",
  "date",
  "singedBy",
  "status",
  "createdAt",
  "Documents",
  "importance",
];
